<div class="wrapper" [ngClass]="{'checkout-item': _variant === VARIANT_CHECKOUT_ITEM, 'cart-item': _variant === VARIANT_CART_ITEM}">
  <app-spinner *ngIf="loading"></app-spinner>
  <div class="container" *ngIf="!loading">
    <div class="item-contents">
      <div class="image-container">
        <img [src]="itemImage">
      </div>
      <div class="item-details">
        <p class="title">{{promoStack._book?.title}}</p>
        <p>
          <span>Promo Date:</span> Starting on {{pubDate}}
        </p>
          <div class="expanded-details" *ngIf="detailsExpanded">
            <p><span>Day(s):</span> {{duration}}</p>
            <p><span>Combined Audience:</span> {{audience}}</p>
            <p><span>Book Price:</span> {{promoStack?.bookPriceDuringPromo | currency:'USD'}}</p>
            <p><span>Promo Stack:</span> {{promoStack._promoStack.name}}</p>
          </div>
          <div class="edit-details">
            <a (click)="toggleDetails()">{{detailsExpanded ? 'Collapse Details' : 'Details'}}</a>
            <div class="dot">&#183;</div>
            <a (click)="editStack()">Edit</a>
          </div>
        </div>
        <div *ngIf="hasValidPromoCode()" class="price-section">
          <div class="sub-section" *ngFor="let detail of discountDetails">
            <p>{{ detail.label }}</p>
            <p class="ml-10">{{ detail.value | currency:'USD' }}</p>
          </div>
        </div>
        <div class="flex align-items-end justify-content-end flex-direction-column">
          <p class="speculative-discount-orinal-price" *ngIf="hasSpeculativeDiscount">
            {{ promoStack._promoStack.discountedPrice | currency:'USD' }}
          </p>
          <p class="total-amount">{{paymentAmount | currency:'USD'}}</p>
          <div class="speculative-discount" *ngIf="hasSpeculativeDiscount">{{ speculativeDiscountText }}</div>
          <div *ngIf="!hasSpeculativeDiscount && showMembershipSaving">
            <div *ngIf="qualifiesForMembershipUpsell" class="speculative-discount-upsell flex">
              <div class="gold">
                <div class="wwm-icon"></div>
              </div>
              {{upsellText}}
            </div>
          </div>
        </div>
      </div>
      <div class="button regular close" (click)="openConfirmationModal()"><span class="icon">&#x00D7;</span></div>
    </div>
  </div>
  <app-confirm-modal
    [modalId]="modalId"
    [text]="confirmText"
    [buttonText]="buttonText"
    (confirmChoice)="onItemRemove($event)"
  ></app-confirm-modal>
<app-error-modal [modalId]="'cart-item-error-modal'" [text]="errorText"></app-error-modal>
